/* eslint-disable react/prop-types */

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";

const RightCaret = () => <FontAwesomeIcon icon={faAngleRight} />;

export default RightCaret;
